import { render, staticRenderFns } from "./GoodsSettingCustomBuyBtn.vue?vue&type=template&id=65b8b614&scoped=true&"
import script from "./GoodsSettingCustomBuyBtn.vue?vue&type=script&lang=js&"
export * from "./GoodsSettingCustomBuyBtn.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSettingCustomBuyBtn.vue?vue&type=style&index=0&id=65b8b614&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b8b614",
  null
  
)

export default component.exports